// Living Portrait — Tesla face animation system.
//
// Module scripts are deferred — DOM is parsed by the time this runs, so we
// don't (and must not) wrap in DOMContentLoaded. Wrapping would miss the event.
//
// `new URL(literal, import.meta.url)` is Parcel 2's officially supported pattern
// for ESM static asset references. The literal path is statically analyzed at
// build time so the asset gets bundled; the runtime returns a real URL string.

const FRAME_URLS = [
    new URL('../images/anim0010.webp', import.meta.url).href,
    new URL('../images/anim0011.webp', import.meta.url).href,
    new URL('../images/anim0012.webp', import.meta.url).href,
    new URL('../images/anim0013.webp', import.meta.url).href,
    new URL('../images/anim0014.webp', import.meta.url).href,
    new URL('../images/anim0015.webp', import.meta.url).href,
    new URL('../images/anim0016.webp', import.meta.url).href,
    new URL('../images/anim0017.webp', import.meta.url).href,
    new URL('../images/anim0018.webp', import.meta.url).href,
    new URL('../images/anim0019.webp', import.meta.url).href,
    new URL('../images/anim0020.webp', import.meta.url).href,
    new URL('../images/anim0021.webp', import.meta.url).href,
    new URL('../images/anim0022.webp', import.meta.url).href,
    new URL('../images/anim0023.webp', import.meta.url).href,
    new URL('../images/anim0024.webp', import.meta.url).href,
    new URL('../images/anim0025.webp', import.meta.url).href,
    new URL('../images/anim0026.webp', import.meta.url).href,
    new URL('../images/anim0027.webp', import.meta.url).href,
    new URL('../images/anim0028.webp', import.meta.url).href,
    new URL('../images/anim0029.webp', import.meta.url).href,
    new URL('../images/anim0030.webp', import.meta.url).href,
    new URL('../images/anim0031.webp', import.meta.url).href,
    new URL('../images/anim0032.webp', import.meta.url).href,
    new URL('../images/anim0033.webp', import.meta.url).href,
    new URL('../images/anim0034.webp', import.meta.url).href,
    new URL('../images/anim0035.webp', import.meta.url).href,
    new URL('../images/anim0036.webp', import.meta.url).href,
    new URL('../images/anim0037.webp', import.meta.url).href,
    new URL('../images/anim0038.webp', import.meta.url).href,
    new URL('../images/anim0039.webp', import.meta.url).href,
    new URL('../images/anim0040.webp', import.meta.url).href,
    new URL('../images/anim0041.webp', import.meta.url).href,
    new URL('../images/anim0042.webp', import.meta.url).href,
    new URL('../images/anim0043.webp', import.meta.url).href,
    new URL('../images/anim0044.webp', import.meta.url).href,
    new URL('../images/anim0045.webp', import.meta.url).href,
    new URL('../images/anim0046.webp', import.meta.url).href,
    new URL('../images/anim0047.webp', import.meta.url).href,
    new URL('../images/anim0048.webp', import.meta.url).href,
    new URL('../images/anim0049.webp', import.meta.url).href,
    new URL('../images/anim0050.webp', import.meta.url).href,
    new URL('../images/anim0051.webp', import.meta.url).href,
    new URL('../images/anim0052.webp', import.meta.url).href,
    new URL('../images/anim0053.webp', import.meta.url).href,
    new URL('../images/anim0054.webp', import.meta.url).href,
    new URL('../images/anim0055.webp', import.meta.url).href,
    new URL('../images/anim0056.webp', import.meta.url).href,
    new URL('../images/anim0057.webp', import.meta.url).href,
    new URL('../images/anim0058.webp', import.meta.url).href,
    new URL('../images/anim0059.webp', import.meta.url).href,
    new URL('../images/anim0060.webp', import.meta.url).href,
    new URL('../images/anim0061.webp', import.meta.url).href,
    new URL('../images/anim0062.webp', import.meta.url).href,
    new URL('../images/anim0063.webp', import.meta.url).href,
    new URL('../images/anim0064.webp', import.meta.url).href,
    new URL('../images/anim0065.webp', import.meta.url).href,
    new URL('../images/anim0066.webp', import.meta.url).href,
    new URL('../images/anim0067.webp', import.meta.url).href,
    new URL('../images/anim0068.webp', import.meta.url).href,
    new URL('../images/anim0069.webp', import.meta.url).href,
    new URL('../images/anim0070.webp', import.meta.url).href,
    new URL('../images/anim0071.webp', import.meta.url).href,
    new URL('../images/anim0072.webp', import.meta.url).href,
    new URL('../images/anim0073.webp', import.meta.url).href,
    new URL('../images/anim0074.webp', import.meta.url).href,
    new URL('../images/anim0075.webp', import.meta.url).href,
    new URL('../images/anim0076.webp', import.meta.url).href,
    new URL('../images/anim0077.webp', import.meta.url).href,
    new URL('../images/anim0078.webp', import.meta.url).href,
    new URL('../images/anim0079.webp', import.meta.url).href,
    new URL('../images/anim0080.webp', import.meta.url).href,
    new URL('../images/anim0081.webp', import.meta.url).href,
    new URL('../images/anim0082.webp', import.meta.url).href,
    new URL('../images/anim0083.webp', import.meta.url).href,
    new URL('../images/anim0084.webp', import.meta.url).href,
    new URL('../images/anim0085.webp', import.meta.url).href,
    new URL('../images/anim0086.webp', import.meta.url).href,
    new URL('../images/anim0087.webp', import.meta.url).href,
    new URL('../images/anim0088.webp', import.meta.url).href,
    new URL('../images/anim0089.webp', import.meta.url).href,
    new URL('../images/anim0090.webp', import.meta.url).href,
    new URL('../images/anim0091.webp', import.meta.url).href,
    new URL('../images/anim0092.webp', import.meta.url).href,
    new URL('../images/anim0093.webp', import.meta.url).href,
    new URL('../images/anim0094.webp', import.meta.url).href,
    new URL('../images/anim0095.webp', import.meta.url).href,
    new URL('../images/anim0096.webp', import.meta.url).href,
    new URL('../images/anim0097.webp', import.meta.url).href,
    new URL('../images/anim0098.webp', import.meta.url).href,
    new URL('../images/anim0099.webp', import.meta.url).href,
    new URL('../images/anim0100.webp', import.meta.url).href,
    new URL('../images/anim0101.webp', import.meta.url).href,
    new URL('../images/anim0102.webp', import.meta.url).href,
    new URL('../images/anim0103.webp', import.meta.url).href,
    new URL('../images/anim0104.webp', import.meta.url).href,
    new URL('../images/anim0105.webp', import.meta.url).href,
    new URL('../images/anim0106.webp', import.meta.url).href,
    new URL('../images/anim0107.webp', import.meta.url).href,
    new URL('../images/anim0108.webp', import.meta.url).href,
    new URL('../images/anim0109.webp', import.meta.url).href,
];

// === Image preload ===

const frames = new Array(FRAME_URLS.length);
let imagesLoaded = 0;

FRAME_URLS.forEach((src, i) => {
    const img = new Image();
    img.onload = () => {
        frames[i] = img;
        imagesLoaded++;
        if (imagesLoaded === FRAME_URLS.length) {
            console.log('All Tesla frames preloaded.');
        }
    };
    img.onerror = () => console.error(`Failed to load Tesla frame: ${src}`);
    img.src = src;
});

// === State machine ===

const STATES = { IDLE: 'idle', THINKING: 'thinking', SPEAKING: 'speaking' };
let state = STATES.IDLE;

const teslaImage = document.getElementById('tesla-image');

function setState(next) {
    if (state === next) return;
    const prev = state;
    state = next;
    if (prev === STATES.SPEAKING) stopCycle();
    if (prev === STATES.THINKING) lightning.disable();
    if (next === STATES.SPEAKING) startCycle();
    if (next === STATES.THINKING) lightning.enable();
    if (next === STATES.IDLE) restToFirstFrame();
}

function restToFirstFrame() {
    if (frames[0]) teslaImage.src = frames[0].src;
}

// === Frame cycling (speaking) ===

const FPS = 24;
const FRAME_DURATION = 1000 / FPS;
let cycleIdx = 0;
let cycleRaf = null;
let cycleLastTs = 0;

function startCycle() {
    if (cycleRaf) return;
    cycleLastTs = 0;
    const tick = (ts) => {
        if (state !== STATES.SPEAKING) {
            cycleRaf = null;
            return;
        }
        if (ts - cycleLastTs >= FRAME_DURATION) {
            const f = frames[cycleIdx];
            if (f) teslaImage.src = f.src;
            cycleIdx = (cycleIdx + 1) % FRAME_URLS.length;
            cycleLastTs = ts;
        }
        cycleRaf = requestAnimationFrame(tick);
    };
    cycleRaf = requestAnimationFrame(tick);
}

function stopCycle() {
    if (cycleRaf) cancelAnimationFrame(cycleRaf);
    cycleRaf = null;
    cycleIdx = 0;
}

// === Lightning overlay (thinking state) ===
//
// Bolts are generated via midpoint-displacement: recursively split a line
// segment, jittering each midpoint, until a jagged path emerges. Each bolt
// fades over a few frames so a steady stream of new bolts produces the
// crackle effect. Drawn with a glow via shadowBlur in the line-art palette.

class LightningOverlay {
    constructor(parent) {
        this.canvas = document.createElement('canvas');
        this.canvas.style.cssText =
            'position:absolute;inset:0;pointer-events:none;mix-blend-mode:screen;';
        parent.style.position = parent.style.position || 'relative';
        parent.appendChild(this.canvas);
        this.ctx = this.canvas.getContext('2d');
        this.bolts = [];
        this.raf = null;
        this.parent = parent;
        this.resize();
        window.addEventListener('resize', () => this.resize());
    }

    resize() {
        const rect = this.parent.getBoundingClientRect();
        const dpr = window.devicePixelRatio || 1;
        this.canvas.width = rect.width * dpr;
        this.canvas.height = rect.height * dpr;
        this.canvas.style.width = rect.width + 'px';
        this.canvas.style.height = rect.height + 'px';
        this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        this.w = rect.width;
        this.h = rect.height;
    }

    enable() {
        if (this.raf) return;
        this.bolts = [];
        const tick = () => {
            if (state !== STATES.THINKING) {
                this.raf = null;
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                this.bolts = [];
                return;
            }
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            // Probabilistically spawn new bolts (cap concurrent count).
            if (Math.random() < 0.18 && this.bolts.length < 4) {
                this.bolts.push(this.makeBolt());
            }
            this.bolts = this.bolts.filter((b) => {
                b.life -= 1;
                if (b.life <= 0) return false;
                this.drawBolt(b);
                return true;
            });
            this.raf = requestAnimationFrame(tick);
        };
        this.raf = requestAnimationFrame(tick);
    }

    disable() {
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = null;
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.bolts = [];
    }

    makeBolt() {
        // Origin lies on a circle near the top of the head; bolts radiate
        // outward through the upper hemisphere.
        const rect = teslaImage.getBoundingClientRect();
        const parentRect = this.parent.getBoundingClientRect();
        const cx = rect.left - parentRect.left + rect.width / 2;
        const cy = rect.top - parentRect.top + rect.height * 0.32;
        const angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 0.9;
        const innerR = Math.min(rect.width, rect.height) * 0.32;
        const outerR = innerR + Math.min(rect.width, rect.height) * (0.18 + Math.random() * 0.3);
        const start = { x: cx + Math.cos(angle) * innerR, y: cy + Math.sin(angle) * innerR };
        const end = { x: cx + Math.cos(angle) * outerR, y: cy + Math.sin(angle) * outerR };
        const maxLife = 7 + Math.floor(Math.random() * 6);
        return {
            points: this.midpointDisplace(start, end, 5, 22),
            life: maxLife,
            maxLife,
            // Optional small fork at a random midpoint.
            fork: Math.random() < 0.4 ? this.makeFork(start, end) : null,
        };
    }

    makeFork(start, end) {
        const t = 0.4 + Math.random() * 0.3;
        const mid = {
            x: start.x + (end.x - start.x) * t,
            y: start.y + (end.y - start.y) * t,
        };
        const dx = end.x - start.x;
        const dy = end.y - start.y;
        const len = Math.hypot(dx, dy) * (0.4 + Math.random() * 0.3);
        const ang = Math.atan2(dy, dx) + (Math.random() < 0.5 ? -1 : 1) * (0.5 + Math.random() * 0.4);
        const tip = { x: mid.x + Math.cos(ang) * len, y: mid.y + Math.sin(ang) * len };
        return this.midpointDisplace(mid, tip, 4, 14);
    }

    midpointDisplace(a, b, depth, jitter) {
        if (depth === 0) return [a, b];
        const mid = {
            x: (a.x + b.x) / 2 + (Math.random() - 0.5) * jitter,
            y: (a.y + b.y) / 2 + (Math.random() - 0.5) * jitter,
        };
        const left = this.midpointDisplace(a, mid, depth - 1, jitter * 0.6);
        const right = this.midpointDisplace(mid, b, depth - 1, jitter * 0.6);
        return [...left.slice(0, -1), ...right];
    }

    drawBolt(b) {
        const t = b.life / b.maxLife;
        const alpha = t;
        // Cyan/green palette to match the line art (rgb 121, 235, 187).
        this.ctx.shadowColor = 'rgba(121, 235, 187, 0.95)';
        this.ctx.shadowBlur = 14;
        this.ctx.lineCap = 'round';
        this.ctx.lineJoin = 'round';
        this.ctx.strokeStyle = `rgba(170, 255, 215, ${alpha})`;
        this.ctx.lineWidth = 1.6;
        this.strokePath(b.points);
        if (b.fork) {
            this.ctx.strokeStyle = `rgba(170, 255, 215, ${alpha * 0.7})`;
            this.ctx.lineWidth = 1.1;
            this.strokePath(b.fork);
        }
    }

    strokePath(points) {
        this.ctx.beginPath();
        this.ctx.moveTo(points[0].x, points[0].y);
        for (let i = 1; i < points.length; i++) {
            this.ctx.lineTo(points[i].x, points[i].y);
        }
        this.ctx.stroke();
    }
}

const lightning = new LightningOverlay(document.getElementById('image-container'));

// === Cursor parallax + idle breathing ===
//
// `transform` is a single CSS property, so parallax and breathing must be
// composed into one string per frame. We lerp toward the cursor target so
// motion is smooth even when the mouse moves discretely.

let cursorTargetX = 0;
let cursorTargetY = 0;
let cursorX = 0;
let cursorY = 0;
const PARALLAX_DEG = 2; // subtle, per user choice.

document.addEventListener('mousemove', (e) => {
    cursorTargetX = e.clientX / window.innerWidth - 0.5; // -0.5..0.5
    cursorTargetY = e.clientY / window.innerHeight - 0.5;
});

let breathPhase = 0;

function presenceLoop() {
    cursorX += (cursorTargetX - cursorX) * 0.06;
    cursorY += (cursorTargetY - cursorY) * 0.06;
    breathPhase += 0.013;
    const breathScale = 1 + Math.sin(breathPhase) * 0.006;
    const ry = cursorX * PARALLAX_DEG;
    const rx = -cursorY * PARALLAX_DEG;
    teslaImage.style.transform =
        `perspective(900px) rotateY(${ry.toFixed(3)}deg) rotateX(${rx.toFixed(3)}deg) scale(${breathScale.toFixed(4)})`;
    requestAnimationFrame(presenceLoop);
}
teslaImage.style.willChange = 'transform';
requestAnimationFrame(presenceLoop);

// === Bridge to existing events ===

document.addEventListener('textUpdate', (event) => {
    const { sentenceEnded } = event.detail;
    setState(sentenceEnded ? STATES.IDLE : STATES.SPEAKING);
});

document.addEventListener('assistantThinking', () => {
    setState(STATES.THINKING);
});
